// 5/24 19:52, SRD_Form 알람항목까지 다 뜸
import { Button, Center } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";

import { NumOfBsd } from "CommonData";
import SRD_Form from "components/Form/index";
import { getBsdList, getChList } from "pages/Admin/Device/apis/adminDeviceApis";
import { getStatusList, insertAlarmItem } from "pages/SMS/ItemSetting/apis/itemSettingApis";

import { currentBsdState } from "pages/Login/atom/currentBsdState";
import { userGroupState } from "pages/Login/atom/userGroupState";
import { currentBsdListState, registedAlarmSetListState } from "pages/atom/globalState";


function ItemSettingAddForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bsd_id, chnnl_no, sms_ment, id,
    operator, set_value, tx_count_, tx_period, alarm_yn } = location.state || {};

  const userGroup = useRecoilValue(userGroupState);

  const [loading, setLoading] = useState(true);
  const [bsdState, setBsdState] = useRecoilState(currentBsdState);
  const [bsdListState, setBsdListState] = useRecoilState(currentBsdListState);
  const [alarmSetListState, setAlarmSetListState] = useRecoilState(registedAlarmSetListState);
  const [ch, setCh] = useState();
  const [chList, setChList] = useState([]);
  
  useEffect(() => { 
    console.log("userGroup > ", userGroup);
    if (userGroup !== 'undefined') {
    getBsdList(NumOfBsd, 1, userGroup).then((res) => {
      if (res && Array.isArray(res)) {
        const filteredList = (res || []).filter((item) => item.group_id === userGroup);
        const formattedBsdList = (filteredList || []).map((item) => ({
          value: item.bsd_id,
          label: item.bsd_nm,
        }));
        setBsdListState(formattedBsdList);
        setLoading(false);
        if (formattedBsdList.length === 0) {
          console.log("선택할 장치 항목이 없습니다.");
        }
      } else {
        console.log("장치 리스트가 로드되지 않았습니다.");
        setBsdListState([]); // 데이터가 없을 경우 빈 배열로 설정
      }
    });
    }
  }, []);

  useEffect(() => { 
    console.log("bsdState > ", bsdState);
    if (userGroup && bsdState) {
      getChList(bsdState).then((res) => {
        if (res && Array.isArray(res)) {
          const filteredList = (res || []).filter((item) => item.bsd_id === bsdState);
          const formattedChList = (filteredList || []).map((item) => ({
            value: item.chnnl_no,
            label: item.chnnl_nm,
          }));
          setChList(formattedChList);
          setLoading(false);
          console.log("formattedChList :", formattedChList);
          if (formattedChList.length === 0) {
            console.log("선택할 채널 항목이 없습니다.");
          }
        } else {
        console.log("채널 리스트가 로드되지 않았습니다.");
        setChList([]); // 데이터가 없을 경우 빈 배열로 설정
      }
      });
    } else {
      setChList([]); // bsd 또는 group이 선택되지 않았을 때 chList를 비웁니다.
    }
  }, [bsdState]);

  const handleChange1 = (event) => {
    console.log("event.target.value:", event.target.value);
    setBsdState(event.target.value);
  };

  const handleChange2 = (event) => {
    console.log("event.target.value:", event.target.value);
    setCh(event.target.value);
  };


  const columns = [
    // {
    //   key: "id",
    //   name: "구분",
    //   type: "text",
    //   defaultValue: "",   // 같은 채널, 다른 메세지 처리위해
    // },
    {
      key: "bsd_nm",
      name: "선택된 분사 장치",
      type: "text",
      defaultValue: bsdListState.find(item => item.value === bsdState)?.label || '기본값',
    },
    {
      key: "chnnl_no",
      name: "알람 항목",
      type: "select",
      options: chList,
      onChangeCustom: (value) => {
        console.log("Selected Channel No:", value);
        setCh(value);
      },
    },
    {
      key: "sms_ment",
      name: "알람 메세지",
      type: "text",
      defaultValue: "",
    },
    {
      key: "operator",
      name: "조건",
      type: "select",
      options: ["=", ">", "<", ">=", "<="],
      defaultValue: "=",
    },
    {
      key: "set_value",
      name: "설정값",
      type: "text",
      options: ["0", "1"],
      defaultValue: "1",
    },
    {
      key: "tx_period",
      name: "재전송주기(분)",
      type: "text",
      defaultValue: 60,
    },
    {
      key: "alarm_yn",
      name: "알람 사용 여부",
      type: "radio_select",
        options: [
          { value: "Y", label: "Yes" },
          { value: "N", label: "No" },
        ],
        defaultValue: "Y",
      },
  ];

  
  const insertNewSmsItem = async (e) => {
    // bsd_id와 chnnl_no로 bsd_sttus_id 찾기
    const res = await getStatusList(bsdState, e.chnnl_no);

      const bsdStatusId = res[0].bsd_sttus_id;
      const filteredList = alarmSetListState.filter(
        (item) => item.bsd_sttus_id === bsdStatusId
      );
      if (filteredList.length !== 0) {
        const sameBsdSttusId = alarmSetListState.some(item => item.bsd_sttus_id === bsdStatusId) ? true : false;
        const operator = filteredList[0].operator;
        const setValue = filteredList[0].set_value;
        const sameOperatorAndSetValue = (e.operator === operator && e.set_value === setValue) ? true : false;
        if (sameBsdSttusId && sameOperatorAndSetValue) {  // 이미 등록된 것이 있으면 메세지로 알림
          alert('이미 등록된 알람 항목이 있습니다');
          return;
        }
      } 
      // 이미 등록된 것이 아니면 등록함
        const bsdNm = res[0].bsd_nm;
        const chnnlNm = res[0].chnnl_nm;
        await insertAlarmItem({
          ...e,
          bsd_sttus_id: bsdStatusId,
          bsd_id: bsdState,
          bsd_nm: bsdNm,
          chnnl_nm: chnnlNm,
        });
      navigate("/sms/item");
  };
  
  const onFormSubmit = (e) => {
    console.log("e: ", e);

    modals.openConfirmModal({
        // title: "저장모달",
        children: <Center>저장 하시겠습니까?</Center>,
        centered: true,
        zIndex: 2000,
        labels: { confirm: "저장", cancel: "취소" },
        onConfirm: () => {
            insertNewSmsItem(e);
        },
    });
  };

  const SubmitButtons = () => {
    const handleCancel = () => {
      navigate("/sms/item");
    };

    return (
      <>
        <Center style={{ marginTop: "1rem", display: "flex", justifyContent: "space-between" }}>
          <Button type="submit" style={{ marginRight: "1rem" }}>저장</Button>
          <Button type="cancel" onClick={handleCancel}>취소</Button>
        </Center>
      </>
    );
  };

  return (
    <>
      <SRD_Form
        fields={columns}
        onSubmit={onFormSubmit}
        submitButton={<SubmitButtons />}
        bsdList={bsdListState.length > 0 ? bsdListState : []}  // bsdList를 prop으로 전달
      />
    </>
  );
};

export default ItemSettingAddForm;
